import styled, { css } from 'styled-components'
import OtpInput from 'react-otp-input'

export const Container = styled.div<{ $isDisabled?: boolean }>`
  display: flex;
  flex-flow: column;

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.4;
    `}
`

export const Input = styled.input``

export const Otp = styled(OtpInput)<{
  $isError?: boolean
  $isDisabled?: boolean
}>`
  input {
    color: ${({ theme }) => theme.colors.pureBlack};
    ${({ theme }) => theme.fonts.BBCondBold};
    font-size: 12px;
  }
`

export const Help = styled.p`
  ${({ theme }) => theme.textStyles.tiny}
  color: grey;
  margin-top: 5px;
`

export const Error = styled.p`
  ${({ theme }) => theme.textStyles.tiny}
  color: ${({ theme }) => theme.colors.red};
  margin-top: 15px;
`
